import { useWallet, WalletType } from "@/providers/wallet";
import { Button } from "@/ui/button";

export const CreateNewWallet = ({ walletType }: { walletType: WalletType }) => {
  const { onWalletCreate } = useWallet();
  const handleCreateWallet = () => {
    onWalletCreate(walletType);
  };
  return (
    <div className="flex flex-row items-center gap-[0.3125rem]">
      <div className="text-white text-xs w-[7rem]">Wallet:</div>
      <Button
        radius="normal"
        active={false}
        title="+ Create New Wallet"
        onClick={handleCreateWallet}
        className="w-[25rem] text-xs"
      />
    </div>
  );
};

export default CreateNewWallet;
